/* 361 Sleep theme — shared behaviour: header, country/language, Shopify cart drawer, order offers, motion.
   Page scripts (dream-mask.js, product.js, collection.js) use window.SITE. Settings and strings come from window.SHOP. */
(() => {
  const S = window.SHOP;
  const body = document.body;
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const fine = matchMedia("(pointer: fine)").matches;
  const coarse = matchMedia("(pointer: coarse), (max-width: 760px)").matches;
  const $ = (id) => document.getElementById(id);

  /* ---------- icons used by script-drawn UI ---------- */
  const svg = (p) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${p}</svg>`;
  const ICON = {
    plus: svg('<path d="M12 5v14M5 12h14"/>'),
    minus: svg('<path d="M5 12h14"/>'),
    close: svg('<path d="M6 6l12 12M18 6 6 18"/>'),
    check: svg('<path d="m5 12.5 4.5 4.5L19 7"/>'),
    truck: svg('<path d="M3 6h11v10H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>'),
  };

  /* ---------- money: whole numbers in the visitor's currency (amounts in cents) ---------- */
  // Display currency may differ from the payment currency (SAR): S.rate converts; checkout charges SAR.
  const fmt = (cents, rate = S.rate || 1) => Math.round(cents / 100 * rate).toLocaleString("en-US");
  function money(cents, sar) {
    const sym = (sar || S.currency === "SAR") ? S.riyal : `<span class="cur">${S.curLabel}</span>`;
    const n = `<span class="num">${fmt(cents, sar ? 1 : undefined)}</span>`;
    if (sar) return `<span class="price" data-cur="SAR">${S.en ? sym + n : n + sym}</span>`;
    return `<span class="price" data-cur="${S.currency}">${S.en ? sym + n : n + sym}<span class="sr"> ${S.curName}</span></span>`;
  }
  const struck = (cents) => `<s class="small num">${fmt(cents)}</s>`;
  const L = (ar, en) => (S.en ? en : ar);
  const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

  /* ---------- country and language (Shopify localization form) ---------- */
  const locForm = $("locForm");
  const submitLoc = (name, value) => { if (!locForm) return; locForm.querySelector(`[name="${name}"]`).value = value; locForm.submit(); };
  const loc = $("loc"), locBtn = $("locBtn");
  const setLoc = (o) => { if (!loc) return; loc.classList.toggle("open", o); locBtn.setAttribute("aria-expanded", String(o)); };
  locBtn?.addEventListener("click", (e) => { e.stopPropagation(); setLoc(!loc.classList.contains("open")); });
  document.addEventListener("click", (e) => {
    const b = e.target.closest("button[data-country]");
    if (b) return submitLoc("country_code", b.dataset.country);
    const l = e.target.closest("button[data-lang]");
    if (l) return submitLoc("language_code", l.dataset.lang);
    if (loc && !loc.contains(e.target)) setLoc(false);
  });

  const main = $("main");
  if (main && !("onpagereveal" in window && document.startViewTransition)) main.classList.add("page-enter");

  /* ---------- header: hide on scroll down, menu pill, mobile sheet ---------- */
  const header = $("header");
  let lastY = scrollY;
  addEventListener("scroll", () => {
    const y = scrollY;
    header?.classList.toggle("hide", y > lastY && y > 260 && !body.classList.contains("lock"));
    lastY = y;
  }, { passive: true });
  const menu = $("menu");
  if (menu) {
    const pill = menu.querySelector(".pill");
    menu.querySelectorAll("a").forEach((a) => a.addEventListener("mouseenter", () => {
      const r = a.getBoundingClientRect(), m = menu.getBoundingClientRect();
      pill.style.width = r.width + "px";
      pill.style.transform = `translateX(${r.left - m.left}px)`;
    }));
  }
  const sheet = $("sheet"), burger = $("burger");
  const setSheet = (open) => { if (!sheet) return; sheet.classList.toggle("open", open); sheet.setAttribute("aria-hidden", String(!open)); burger.setAttribute("aria-expanded", String(open)); body.classList.toggle("lock", open); };
  burger?.addEventListener("click", () => setSheet(true));
  $("sheetClose")?.addEventListener("click", () => setSheet(false));

  /* ---------- cart: Shopify Ajax API ---------- */
  const drawer = $("drawer"), scrim = $("scrim"), cartBtn = $("cartBtn");
  const R = S.routes;
  const post = (url, data) => fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(data) })
    .then(async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || S.str.error); return j; });
  const getCart = () => fetch(R.cartJs, { headers: { Accept: "application/json" } }).then((r) => r.json());

  /* compare-at prices are not in cart.js: read them once per product from /products/<handle>.js */
  const WAS = (() => { try { return JSON.parse(sessionStorage.getItem("wasMap:" + S.payCurrency) || "{}"); } catch (e) { return {}; } })();
  const wasFor = (items) => Promise.all([...new Set(items.filter((i) => !(i.variant_id in WAS)).map((i) => i.handle))].map((h) =>
    fetch(`${R.root.replace(/\/$/, "")}/products/${h}.js`).then((r) => r.json()).then((p) => p.variants.forEach((v) => (WAS[v.id] = v.compare_at_price || 0))).catch(() => {})))
    .then(() => { try { sessionStorage.setItem("wasMap:" + S.payCurrency, JSON.stringify(WAS)); } catch (e) {} });
  const lineWas = (i) => Math.max((WAS[i.variant_id] || 0) * i.quantity, i.original_line_price);

  function renderCart(c) {
    const n = c.item_count;
    $("cartCount").textContent = n;
    cartBtn?.classList.toggle("has-items", n > 0);
    $("cartItems").innerHTML = c.items.length ? c.items.map((i, idx) => {
      const img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : "";
      const sub = [i.variant_title && !/default/i.test(i.variant_title) ? i.variant_title : "", ...i.line_level_discount_allocations.map((d) => d.discount_application.title)].filter(Boolean).join(" · ");
      const was = lineWas(i);
      return `<div class="line"><a href="${i.url}"><img src="${img}" alt=""></a>
        <div><b><bdi>${esc(i.product_title)}</bdi></b>${sub ? `<span class="small" style="display:block">${esc(sub)}</span>` : ""}<span class="line-p">${money(i.final_line_price)}${was > i.final_line_price ? ` ${struck(was)}` : ""}</span>
          <div class="qty" style="display:inline-flex"><button type="button" data-line="${idx + 1}" data-q="${i.quantity - 1}" aria-label="${esc(S.str.less)}">${ICON.minus}</button><output>${i.quantity}</output><button type="button" data-line="${idx + 1}" data-q="${i.quantity + 1}" aria-label="${esc(S.str.more)}">${ICON.plus}</button></div></div>
        <button type="button" class="rm" data-line="${idx + 1}" data-q="0">${esc(S.str.remove)}</button></div>`;
    }).join("") : `<div class="empty-cart"><p class="h3" style="color:var(--cream)">${esc(S.str.emptyTitle)}</p><p>${esc(S.str.emptyBody)}</p><a class="btn btn-glass" href="${R.shop}" style="margin-top:1rem">${esc(S.str.shopNow)}</a></div>`;
    const before = c.items.reduce((a, i) => a + lineWas(i), 0);
    const saved = Math.max(0, before - c.total_price);
    $("cartFoot").innerHTML = c.items.length ? `
      <div class="sum"><span>${esc(S.str.total)}</span><span class="sum-p">${saved > 0 ? `<s class="was num">${fmt(before)}</s>` : ""}${money(c.total_price)}</span></div>
      ${saved > 0 ? `<p class="saved-pill">${ICON.check || ""}<span>${esc(S.str.saved)} ${money(saved)}</span></p>` : ""}
      ${S.currency !== S.payCurrency ? `<p class="small pay-sar" style="margin:0">${esc(S.str.paySar)} ${money(c.total_price, true)}</p>` : ""}
      <p class="small" style="margin:0">${ICON.truck} ${esc(S.ship)}</p>
      <p class="small" style="margin:0">${esc(S.str.shipNote)}${S.payNames ? ` ${esc(S.str.instalWith)} ${esc(S.payNames)}.` : ""}</p>
      ${S.payImgs ? `<div class="pay-row">${S.payImgs}</div>` : ""}
      <button class="btn btn-sand btn-block" type="submit" name="checkout">${esc(S.str.checkout)}</button>` : "";
  }
  const refreshCart = () => getCart().then((c) => wasFor(c.items).then(() => renderCart(c)));
  function openCart(open = true) {
    if (!drawer) return;
    drawer.classList.toggle("open", open); scrim.classList.toggle("open", open); drawer.setAttribute("aria-hidden", String(!open)); drawer.inert = !open; body.classList.toggle("lock", open);
    if (open) setTimeout(() => $("drawerClose")?.focus({ preventScroll: true }), 60);
  }
  if (drawer) drawer.inert = !drawer.classList.contains("open");

  const toastEl = $("toast");
  let tt;
  function toast(img, msg) {
    toastEl.innerHTML = `${img ? `<img src="${img}" alt="">` : ""}<span>${esc(msg || S.str.added)}</span>${msg ? "" : `<button type="button" class="btn btn-cream" style="min-height:2.4rem;padding-inline:1.1rem" data-open-cart>${esc(S.str.viewCart)}</button>`}`;
    toastEl.classList.add("show"); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove("show"), 3200);
  }
  /* items: [{ id: variantId, quantity, properties? }] */
  function addItems(items, img) {
    return post(R.cartAdd, { items }).then(() => refreshCart()).then(() => {
      cartBtn?.classList.remove("bump"); void cartBtn?.offsetWidth; cartBtn?.classList.add("bump");
      toast(img);
    }).catch((err) => toast(img, err.message));
  }
  const change = (line, quantity) => post(R.cartChange, { line: Number(line), quantity: Math.max(0, Number(quantity)) }).then((c) => wasFor(c.items).then(() => renderCart(c))).catch((e) => toast("", e.message));

  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-add],[data-line],[data-open-cart]");
    if (!t) return;
    if (t.dataset.add) { e.preventDefault(); addItems([{ id: Number(t.dataset.add), quantity: Number(t.dataset.qty || 1) }], t.dataset.img); }
    else if (t.dataset.line) change(t.dataset.line, t.dataset.q);
    else if (t.hasAttribute("data-open-cart")) { toastEl.classList.remove("show"); openCart(true); }
  });
  cartBtn?.addEventListener("click", () => openCart(true));
  $("drawerClose")?.addEventListener("click", () => openCart(false));
  scrim?.addEventListener("click", () => openCart(false));
  addEventListener("keydown", (e) => { if (e.key !== "Escape") return; if (drawer?.classList.contains("open")) openCart(false); if (sheet?.classList.contains("open")) setSheet(false); });
  addEventListener("pageshow", (e) => { if (e.persisted) refreshCart(); });
  if (drawer) refreshCart();

  /* product forms rendered by Liquid (cards, simple buy buttons) post through Ajax too */
  document.addEventListener("submit", (e) => {
    const f = e.target.closest("form[action*='/cart/add']");
    if (!f || f.hasAttribute("data-native")) return;
    e.preventDefault();
    const fd = new FormData(f);
    addItems([{ id: Number(fd.get("id")), quantity: Number(fd.get("quantity") || 1) }], f.dataset.img);
  });

  /* ---------- order offers ----------
     Markup comes from snippets/offers.liquid. The buy root [data-buy] carries the selected variant
     (data-variant-id, data-price, data-compare, data-img); colour pickers update those and call sync().
     Prices shown here are previews: the real saving is applied at checkout by the store's automatic discounts. */
  function bindOffers(root) {
    const box = root.querySelector("[data-offers]");
    const addBtn = root.querySelector("[data-buy-add]");
    const priceEl = root.querySelector("[data-buy-price]");
    const qtyEl = root.querySelector("[data-qty-input]");
    const pick = () => {
      const v = root.dataset;
      const base = { id: Number(v.variantId), price: Number(v.price), compare: Math.max(Number(v.compare || 0), Number(v.price)) };
      if (!box) return { items: [{ id: base.id, quantity: 1 }], price: base.price, was: base.compare };
      const input = box.querySelector("input:checked") || box.querySelector("input");
      const o = input.closest("[data-offer]");
      const pct = Number(o.dataset.pct || 0), qty = Number(o.dataset.qty || 1);
      const sel = o.querySelector("select[data-addon]");
      if (sel) {
        const opt = sel.selectedOptions[0];
        const ap = Number(opt.dataset.price), ac = Math.max(Number(opt.dataset.compare || 0), ap);
        return { items: [{ id: base.id, quantity: 1 }, { id: Number(sel.value), quantity: 1 }], price: Math.round((base.price + ap) * (1 - pct / 100)), was: base.compare + ac };
      }
      return { items: [{ id: base.id, quantity: qty }], price: Math.round(base.price * qty * (1 - pct / 100)), was: base.compare * qty };
    };
    const paint = () => {
      if (box) box.querySelectorAll("[data-offer]").forEach((o) => {
        const v = root.dataset, pct = Number(o.dataset.pct || 0), qty = Number(o.dataset.qty || 1);
        const bp = Number(v.price), bc = Math.max(Number(v.compare || 0), bp);
        const sel = o.querySelector("select[data-addon]");
        let p, w;
        if (sel) { const opt = sel.selectedOptions[0]; const ap = Number(opt.dataset.price); p = Math.round((bp + ap) * (1 - pct / 100)); w = bc + Math.max(Number(opt.dataset.compare || 0), ap); }
        else { p = Math.round(bp * qty * (1 - pct / 100)); w = bc * qty; }
        o.querySelector("[data-pr]").innerHTML = money(p) + (w > p ? struck(w) : "");
      });
      const o = pick();
      if (priceEl) priceEl.innerHTML = money(o.price) + (o.was > o.price ? ` ${struck(o.was)}` : "");
      root.dispatchEvent(new CustomEvent("offer", { detail: o }));
      return o;
    };
    box?.addEventListener("change", paint);
    box?.querySelectorAll("select[data-addon]").forEach((sel) => sel.addEventListener("click", () => { const r = sel.closest("[data-offer]").querySelector("input"); if (!r.checked) { r.checked = true; paint(); } }));
    root.querySelectorAll("[data-qty-step]").forEach((b) => b.addEventListener("click", () => { qtyEl.value = Math.min(9, Math.max(1, Number(qtyEl.value) + Number(b.dataset.qtyStep))); if (qtyEl.tagName === "OUTPUT") qtyEl.textContent = qtyEl.value; }));
    addBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      const o = pick(), times = Number(qtyEl?.value || 1);
      addBtn.disabled = true;
      addItems(o.items.map((i) => ({ ...i, quantity: i.quantity * times })), root.dataset.img).finally(() => { addBtn.disabled = false; });
    });
    paint();
    return paint;
  }

  /* ---------- reveal ---------- */
  function splitWords(root = document) {
    root.querySelectorAll("[data-words]:not(.words)").forEach((el) => {
      let i = 0;
      const walk = (node) => {
        [...node.childNodes].forEach((n) => {
          if (n.nodeType === 3) {
            const frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach((part) => {
              if (!part) return;
              if (/^\s+$/.test(part)) frag.append(part);
              else { const s = document.createElement("span"); s.className = "w"; s.style.setProperty("--i", i++); s.textContent = part; frag.append(s); }
            });
            n.replaceWith(frag);
          } else if (n.nodeType === 1 && n.tagName !== "BR") walk(n);
        });
      };
      walk(el);
      el.classList.add("words");
      el.setAttribute("data-reveal-words", "");
    });
  }
  const io = new IntersectionObserver((entries) => entries.forEach((en) => {
    if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
  }), { rootMargin: "0px 0px -10% 0px", threshold: .08 });
  const moodIO = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting && en.target.dataset.mood) body.dataset.mood = en.target.dataset.mood; }), { rootMargin: "-45% 0px -45% 0px" });
  const watchMoods = () => document.querySelectorAll("[data-mood]:not(body):not([data-mw])").forEach((s) => { s.dataset.mw = 1; moodIO.observe(s); });
  function bindGlass(el) {
    if (!fine || el.dataset.gl) return;
    el.dataset.gl = 1;
    el.addEventListener("pointermove", (e) => {
      const r = el.getBoundingClientRect();
      el.style.setProperty("--mx", `${e.clientX - r.left}px`);
      el.style.setProperty("--my", `${e.clientY - r.top}px`);
    }, { passive: true });
  }
  function observe(root = document) {
    watchMoods();
    splitWords(root);
    root.querySelectorAll("[data-reveal]:not(.in), .words:not(.in)").forEach((el) => io.observe(el));
    root.querySelectorAll(".glass").forEach(bindGlass);
  }
  /* in the theme editor everything shows at once, so merchants see what they edit */
  if (window.Shopify && Shopify.designMode) document.documentElement.classList.add("design-mode");

  /* ---------- parallax, sticky horizontal story ---------- */
  let par = [], hs = [];
  const rescan = () => { par = [...document.querySelectorAll("[data-parallax]")]; hs = [...document.querySelectorAll(".hscroll")]; };
  function sizeH() {
    /* phones swipe the story natively instead of turning vertical scroll into sideways motion */
    if (coarse) { hs.forEach((s) => s.classList.add("native")); hs = []; return; }
    hs.forEach((s) => {
      const track = s.querySelector(".track");
      const dist = Math.max(0, track.scrollWidth - innerWidth);
      s.style.height = `calc(100svh + ${dist}px)`;
      s._dist = dist;
    });
  }
  function frame() {
    const vh = innerHeight;
    if (!reduce && !coarse) par.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const k = Number(el.dataset.parallax || .12);
      el.style.transform = `translate3d(0, ${((r.top + r.height / 2 - vh / 2) * -k).toFixed(1)}px, 0)`;
    });
    const sign = document.documentElement.dir === "ltr" ? -1 : 1;
    hs.forEach((s) => {
      const r = s.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, -r.top / ((s.offsetHeight - vh) || 1)));
      s.querySelector(".track").style.transform = `translate3d(${(sign * p * s._dist).toFixed(1)}px, 0, 0)`;
      const bar = s.querySelector(".progress i"); if (bar) bar.style.setProperty("--p", p.toFixed(3));
    });
  }
  let ticking = false;
  addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { frame(); ticking = false; }); } }, { passive: true });
  addEventListener("resize", () => { sizeH(); frame(); });

  /* ---------- magnetic buttons ---------- */
  function magnet(root = document) {
    if (!fine || reduce) return;
    root.querySelectorAll("[data-magnetic]:not([data-mg])").forEach((b) => {
      b.dataset.mg = 1;
      b.addEventListener("pointermove", (e) => {
        const r = b.getBoundingClientRect();
        b.style.setProperty("--mgx", `${((e.clientX - r.left) / r.width - .5) * 14}px`);
        b.style.setProperty("--mgy", `${((e.clientY - r.top) / r.height - .5) * 10}px`);
      });
      b.addEventListener("pointerleave", () => { b.style.setProperty("--mgx", "0px"); b.style.setProperty("--mgy", "0px"); });
    });
  }

  /* hand the card image to the product page so it morphs across the navigation */
  document.addEventListener("click", (e) => {
    const a = e.target.closest("a[data-hero]");
    const img = a?.closest(".card")?.querySelector("img.main");
    if (img) { document.querySelectorAll(".stage-main img").forEach((i) => (i.style.viewTransitionName = "none")); img.style.viewTransitionName = "product-hero"; }
  });
  addEventListener("pageshow", () => document.querySelectorAll("img.main").forEach((i) => (i.style.viewTransitionName = "")));

  /* buy roots on the page wire themselves */
  const init = (root = document) => { rescan(); observe(root); magnet(root); sizeH(); frame(); root.querySelectorAll("[data-buy]:not([data-bound])").forEach((b) => { b.dataset.bound = 1; b._sync = bindOffers(b); }); };
  /* theme editor: re-run when a section is added or changed */
  document.addEventListener("shopify:section:load", (e) => init(e.target));

  window.SITE = { ICON, money, struck, fmt, L, esc, addItems, openCart, refreshCart, observe, magnet, bindOffers, refresh() { rescan(); sizeH(); frame(); } };
  addEventListener("load", () => { sizeH(); frame(); });
  init();
})();

/* links to a FAQ answer (#faq-…) open that answer before scrolling to it */
document.addEventListener("click", (e) => {
  const a = e.target.closest("a[href^='#faq-']");
  const d = a && document.getElementById(a.getAttribute("href").slice(1));
  if (d && d.tagName === "DETAILS") d.open = true;
});

/* story carousel on phones (.hscroll.native): dots that follow the swipe, and a gentle auto swipe that stops once touched */
(() => {
  const setup = () => document.querySelectorAll(".hscroll.native").forEach((sec) => {
    if (sec._dots) return;
    const track = sec.querySelector(".track"), dots = sec.querySelector(".hs-dots");
    if (!track || !dots) return;
    sec._dots = true;
    const items = [...track.children];
    dots.innerHTML = items.map(() => "<i></i>").join("");
    const ds = [...dots.children];
    let cur = 0, stopped = false, timer;
    const mark = (i) => { cur = i; ds.forEach((d, k) => d.classList.toggle("on", k === i)); };
    mark(0);
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) mark(items.indexOf(e.target)); }), { root: track, threshold: .6 });
    items.forEach((it) => io.observe(it));
    const go = (i) => track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: "smooth" });
    const stop = () => { stopped = true; clearInterval(timer); };
    ["touchstart", "pointerdown", "wheel"].forEach((ev) => track.addEventListener(ev, stop, { passive: true }));
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    // only run while the carousel is on screen
    const vis = new IntersectionObserver(([e]) => {
      clearInterval(timer);
      if (e.isIntersecting && !stopped) timer = setInterval(() => { if (!document.hidden) go((cur + 1) % items.length); }, 3800);
    }, { threshold: .4 });
    vis.observe(sec);
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setup); else setup();
  addEventListener("load", setup);
})();
